
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addJobEducationCourse, deleteJobEducationCourse, fetchEducationCourse, fetchJobEducationCourse, updateJobEducationCourse } from "./JobEducationCourceAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchJobEducationCourseAsync = createAsyncThunk(
  "jobEducationCourse/fetch",
  async (selectedDegreeUuid, { rejectWithValue }) => {
    try {
      const data = await fetchJobEducationCourse(selectedDegreeUuid);
      const resp = data.response;
      // console.log("data's response", data.response)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchEducationCourseAsync = createAsyncThunk(
  "EducationCourse/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchEducationCourse();
      const resp = data.response;
      // console.log("data's response", data.response)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteJobEducationCourseAsync = createAsyncThunk(
  'jobEducationCourse/delete',
  async (uuid, { rejectWithValue }) => {
    try {
      await deleteJobEducationCourse(uuid);
      return uuid; 
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const updateJobEducationCourseAsync = createAsyncThunk(
  'jobEducationCourse/update',
  async ({ uuid, jobEducationCourseData }, { rejectWithValue }) => {
    try {
      const response = await updateJobEducationCourse(uuid, jobEducationCourseData);
      // console.log("Response Slice", response)
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addJobEducationCourseAsync = createAsyncThunk(
  "jobEducationCourse/add",
  async (jobEducationCourseData) => {
    try {
      const data = await addJobEducationCourse(jobEducationCourseData);
      // console.log("data in slice", data)
      return data;
    } catch (error) {
      // console.log("errorL :" , error)
      return error
      // return rejectWithValue(error.message);
    }
  }
);

const jobEducationCourseSlice = createSlice({
  name: "jobEducationCourse",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobEducationCourseAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobEducationCourseAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchJobEducationCourseAsync.rejected, (state, action) => {
        state.loading = false;
        // state.error = action.payload || action.error.message;
        state.error = action.error.message || "An error occurred"; // Store only the message
      })
      .addCase(fetchEducationCourseAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEducationCourseAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchEducationCourseAsync.rejected, (state, action) => {
        state.loading = false;
        // state.error = action.payload || action.error.message;
        state.error = action.error.message || "An error occurred"; // Store only the message
      })

      
      .addCase(addJobEducationCourseAsync.fulfilled, (state, action) => {
        state.data?.push(action.payload);
      })
      .addCase(addJobEducationCourseAsync.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(updateJobEducationCourseAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateJobEducationCourseAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (!state.data) {
          state.data = [];
        }
        state.data = state.data.map((jobTitle) =>
          jobTitle.uuid === action.payload.uuid ? action.payload : jobTitle
        );
      })
      .addCase(updateJobEducationCourseAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(deleteJobEducationCourseAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteJobEducationCourseAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter(
          (jobEducationCourse) => jobEducationCourse.uuid !== action.payload
        );
      })
      .addCase(deleteJobEducationCourseAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});
export const selectJobEducationCourse = (state) => state.jobEducationCourse.data;

export default jobEducationCourseSlice.reducer;
